import styled from "styled-components";
import { TypeColorNames } from "../../../theme/colors";

interface IExitIcon {
    style?: any;
    onClick?: any;
    color?: TypeColorNames;
    colorHover?: TypeColorNames;
}

const IconContainer = styled.span<{color?: TypeColorNames, colorHover?: TypeColorNames}>`
    display: flex;
    align-items: center;
    
    svg {
        fill:${(props) => props.color ? props.theme.colors[props.color] : props.theme.colors.placeholder};
    }

    svg:hover {
        fill: ${(props) => props.colorHover ? props.theme.colors[props.colorHover] : props.theme.colors.label};
    }
`;

const ExitIcon: React.FC<IExitIcon> = ({style, onClick, color, colorHover}) => {
    return (
        <IconContainer style={style} onClick={onClick} color={color} colorHover={colorHover}>
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.86477 5.00039L9.82068 1.04482C10.0598 0.805562 10.0598 0.418706 9.82068 0.180999C9.58159 -0.0582619 9.195 -0.0582619 8.95746 0.180999L5 4.13501L1.04254 0.179445C0.803447 -0.0598154 0.416861 -0.0598154 0.17932 0.179445C-0.0597733 0.418706 -0.0597733 0.805562 0.17932 1.04327L4.13523 4.99883L0.17932 8.95595C-0.0597733 9.19521 -0.0597733 9.58207 0.17932 9.81978C0.298867 9.93941 0.455675 9.99845 0.61093 9.99845C0.767738 9.99845 0.922993 9.93941 1.04254 9.81978L5 5.86421L8.95746 9.82133C9.07701 9.94096 9.23226 10 9.38907 10C9.54588 10 9.70113 9.94096 9.82068 9.82133C10.0598 9.58207 10.0598 9.19521 9.82068 8.95751L5.86477 5.00039Z" />
            </svg>

        </IconContainer>
    )
}

export default ExitIcon;

